import { render } from "./RoomTab.vue?vue&type=template&id=792c876d"
import script from "./RoomTab.vue?vue&type=script&lang=js"
export * from "./RoomTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__